import { CircleInfoIcon, Typography } from '@execonline-inc/execonline-ui';
import { noop } from '@kofno/piper';
import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import { previewStore } from '../../LearningCollectionPreviewStore';
import { T } from '../../../../../../Translations';
import Exploration from '../../../../Details/Exploration';
import Tooltip from '../../../../Details/Exploration/Tooltip';
import Details from './Details';
import LearningCollectionDetails from './LearningCollectionDetails';

function Ready() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (previewStore.state.kind === 'recommendations-incoming' && containerRef.current) {
      containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- MobX observer re-renders but useEffect needs this dep to re-fire on state transitions
  }, [previewStore.state.kind]);

  return (
    <div ref={containerRef} className="overflow-auto flex absolute flex-col w-full inset-0">
      <div className="flex justify-center items-center border bg-zinc-50 p-2.5">
        <Typography
          color="teal"
          fontWeight="semibold"
          className="mr-2"
          variant="bodyMedium"
          data-testid="execonline-participant-preview"
          data-intercom-target="participant-preview-indicator"
        >
          <T kind="Participant Preview" />
        </Typography>
        <CircleInfoIcon color="teal" size="md" />
      </div>
      <div className="mx-auto box-border px-6 pb-8 pt-11 xl:container md:px-14">
        <LearningCollectionDetails mode="Preview" onChange={noop} />
        <Tooltip content={<T kind="Search and filters not active in preview mode" />}>
          <Exploration disabled={true} />
        </Tooltip>
      </div>
      <Details />
    </div>
  );
}

export default observer(Ready);
